import React from 'react';
import './Footer.css';

const Footer = () => (
  <footer className="footer-section">
    <div className="footer-left">
      <span className="footer-copyright">Copyright © {new Date().getFullYear()} <span style={{color: 'rgb(255, 166, 0)'}}>Drive-in Car Spa Pvt Ltd</span>.</span>
      <span className="footer-site">Designed and Developed by
        <a href="https://www.digiworq.com" target="_blank" rel="noopener noreferrer" style={{ color: 'rgb(255, 166, 0)', textDecoration: 'none' }}> Digiworq</a>
      </span>
    </div>
    <div className="footer-right">
      <a href="/privacypolicy" className="footer-link">Privacy Policy</a>
      <span className="footer-sep">|</span>
      <a href="/terms" className="footer-link">Terms & Conditions</a>
    </div>
  </footer>
);

export default Footer; 